import androidx.compose.runtime.*
import org.jetbrains.compose.web.attributes.placeholder
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.css.LineStyle.Companion.Solid
import org.jetbrains.compose.web.dom.ContentBuilder
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Text
import org.jetbrains.compose.web.dom.TextInput
import org.w3c.dom.HTMLDivElement

enum class ButtonState {
    YES, NO, NONE
}

fun StyleBuilder.myButtonStyle(state: ButtonState = ButtonState.NONE) {
    height(30.px)
    borderRadius(10.px)
    margin(3.px)
    cursor("pointer")
    border {
        style(Solid)
        width(1.px)
        color(Color.lightgray)
    }
    when (state) {
        ButtonState.YES -> backgroundColor(Color("#DDFFDD"))
        ButtonState.NO -> backgroundColor(Color("#FFDDDD"))
        ButtonState.NONE -> backgroundColor(Color("#EEEEFF"))
    }
}

@Composable
fun <TraitType> FilterBox(
    title: String,
    hasFilter: Boolean,
    traits: List<TraitType>,
    filterFunction: ((String, TraitType) -> Boolean)?,
    buttons: ContentBuilder<HTMLDivElement>? = null,
    lineBuilder: @Composable() ((TraitType) -> Unit)?
) {
    var search: String by remember { mutableStateOf("") }
    Div({
        style {
            display(DisplayStyle.Flex)
            flexDirection(FlexDirection.Column)
            maxHeight(300.px)
            maxWidth(400.px)
            margin(10.px)
            padding(5.px)
            backgroundColor(Color.white)
            if (hasFilter) {
                outline(Color.green, "solid", 5.px)
            }
            border {
                width(1.px)
                color(Color.lightgray)
                style(Solid); borderRadius(5.px)
            }
        }
    }) {
        Div({ style { fontWeight("bold"); padding(5.px) } }) {
            Text(title)
            if (filterFunction != null) {
                TextInput(search) {
                    style { marginLeft(10.px) }
                    placeholder("search")
                    onInput { newText ->
                        search = newText.value
                    }
                }
            }
        }
        Div(null, buttons)
        Div({
            style {
                flex(1)
                display(DisplayStyle.Block)
                padding(5.px)
                overflowY("auto")
            }
        }) {
            if (lineBuilder == null) {
                return@Div
            }
            var even = false
            for (item in traits) {
                if (filterFunction != null && !filterFunction(search, item)) {
                    continue
                }
                Div({
                    style {
                        if (even) {
                            backgroundColor(Color.white)
                        } else {
                            backgroundColor(Color("#F3F3F3"))
                        }
                    }
                }) {
                    lineBuilder(item)
                }
                even = !even
            }
        }
    }
}